import findReadWriteRecipient from '../actions/findReadWriteRecipient';
import { AtMentionsViewState } from '../store/schema/AtMentionsViewState';
import { observer } from 'mobx-react';
import { Callout, DirectionalHint } from 'office-ui-fabric-react/lib/Callout';
import { getRTL } from 'office-ui-fabric-react/lib/Utilities';
import { IPoint } from 'office-ui-fabric-react/lib/Utilities';
import FindRecipient from 'owa-recipient-common/lib/components/FindRecipient';
import { DirectorySearchType } from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {
    AT_MENTION_RECIPIENT_SUGGESTION_LABEL_PREFIX,
    AT_MENTION_RECIPIENT_SUGGESTIONS_LABEL,
} from '../constants';
import FindRecipientInfo, {
    FindRecipientInfoType,
} from 'owa-recipient-common/lib/components/FindRecipientInfo';

const styles = require('./AtMentionsResult.scss');
const classNames = require('classnames/bind').bind(styles);

export interface AtMentionsResultProps {
    target: IPoint;
    bufferZone: number;
    viewState: AtMentionsViewState;
    addRecipientAction: (recipient: FindRecipientPersonaType, wordBeforeCursor: string) => void;
}

@observer
export default class AtMentionsResult extends React.Component<AtMentionsResultProps, any> {
    private searchDirectoryAction = () => {
        findReadWriteRecipient(
            this.props.viewState,
            this.props.viewState.queryString,
            true /* searchDirectory */
        );
    };

    private addRecipientAction = (viewState: AtMentionsViewState) => (
        recipientToAdd: FindRecipientPersonaType
    ) => {
        this.props.addRecipientAction(recipientToAdd, viewState.wordBeforeCursor);
    };

    private getInfoElementType(viewState: AtMentionsViewState): FindRecipientInfoType {
        const hasQueryString = !!viewState.queryString;
        if (viewState.isSearching) {
            return FindRecipientInfoType.Searching;
        } else if (!hasQueryString && viewState.findResultSet.length == 0) {
            return FindRecipientInfoType.TypeToSearch;
        } else if (hasQueryString) {
            if (viewState.directorySearchType == DirectorySearchType.None) {
                return FindRecipientInfoType.SearchDirectory;
            } else {
                return FindRecipientInfoType.TopNResults;
            }
        }

        return FindRecipientInfoType.Default;
    }

    render() {
        const { viewState, target, bufferZone } = this.props;
        return viewState.isPopupShown ? (
            <Callout
                className={styles.callout}
                gapSpace={bufferZone}
                target={target}
                isBeakVisible={false}
                setInitialFocus={false}
                directionalHint={
                    getRTL() ? DirectionalHint.bottomRightEdge : DirectionalHint.bottomLeftEdge
                }>
                {viewState.findResultSet.length != 0 && (
                    <div className={classNames(styles.scrollContainer, 'customScrollBar')}>
                        <div
                            id={AT_MENTION_RECIPIENT_SUGGESTION_LABEL_PREFIX}
                            className={styles.recipientCollection}
                            role="list">
                            {viewState.findResultSet.map((result, index) => (
                                <div
                                    key={result.EmailAddress.EmailAddress}
                                    id={AT_MENTION_RECIPIENT_SUGGESTIONS_LABEL + index.toString()}
                                    role="listitem">
                                    <FindRecipient
                                        findRecipient={result}
                                        isHighlighted={viewState.selectedRecipientIndex == index}
                                        addRecipientAction={this.addRecipientAction(viewState)}
                                        maskRecipientAction={null}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                <FindRecipientInfo
                    infoType={this.getInfoElementType(viewState)}
                    queryString={viewState.queryString}
                    highlighted={viewState.findResultSet.length == viewState.selectedRecipientIndex}
                    numberOfResults={viewState.findResultSet.length}
                    searchDirectoryAction={this.searchDirectoryAction}
                />
            </Callout>
        ) : null;
    }
}

export function showAtMentionsPopup(
    targetPoint: IPoint,
    bufferZone: number,
    viewState: AtMentionsViewState,
    popupDiv: HTMLDivElement,
    addRecipientAction: (recipient: FindRecipientPersonaType) => void
): void {
    ReactDOM.render(
        <AtMentionsResult
            target={targetPoint}
            bufferZone={bufferZone}
            viewState={viewState}
            addRecipientAction={addRecipientAction}
        />,
        popupDiv
    );
}

export function disposeAtMentionsPopup(popupDiv: HTMLDivElement): void {
    ReactDOM.unmountComponentAtNode(popupDiv);
}
